export const ICONS = {
    COMMON: {
        PROFILE: 'common/profile',
        STATUS: 'common/status',
        PRIORITY: 'common/priority',
        LEADER: 'common/leader',
        CONTRIBUTOR: 'common/contributor',
        PROJECT: 'common/project',
        DUE_DATE: 'common/due_date',
        CALENDAR: 'common/calendar',
        PERSONAL_REPORT: 'common/personal_report',
        TEAM_REPORT: 'common/team_report',
    },
    ARROW: {
        EXPAND: 'arrow/expand',
        COLLAPSE: 'arrow/collapse',
        FEEDBACK_ARROW: 'arrow/feedback',
    },
    GOAL: {
        BACKLOG: 'goal/backlog',
        PLANNED: 'goal/planned',
        IN_PROGRESS: 'goal/in_progress',
        AT_RISK: 'goal/at_risk',
        COMPLETED: 'goal/completed',
        PAUSED: 'goal/paused',
        CANCELED: 'goal/canceled',
    },
    PRIORITY: {
        HIGHEST: 'priority/highest',
        HIGH: 'priority/high',
        MEDIUM: 'priority/medium',
        LOW: 'priority/low',
        LOWEST: 'priority/lowest',
    },
    INDICATOR: {
        DOLLAR: 'indicator/dollar',
        NUMBER: 'indicator/number',
        PERCENT: 'indicator/percent',
        WON: 'indicator/won',
    },
    NOTE: {
        NOTE: 'note/note',
        LINK: 'note/link',
    },
    AI: {
        ASSISTANT: 'ai/assistant',
        TRANSLATE: 'ai/translate',
        ASK_AI: 'ai/ask_ai',
        AI_MAIL: 'ai/mail',
        AI_TASK: 'ai/task',
        AI_LINK: 'ai/link',
        AIREPORT: 'ai/aireport',
        LAIKA_LOGO: 'ai/laika_logo',
        LAIKA_CORNER: 'ai/laika_corner',
        LAIKA_FLOATING: 'ai/laika_floating',
        LAIKA_FOOTPRINT: 'ai/laika_footprint',
    },
    TODO: {
        ADD: 'todo/todo_add',
        NOW: 'todo/now',
    },
} as const;

// 타입 추론을 위한 타입 정의
type ValueOf<T> = T[keyof T];
type FlattenObject<T> = {
    [K in keyof T]: ValueOf<T[K]>;
}[keyof T];

export type IconName = FlattenObject<typeof ICONS>;
